/* === AmourPrint CRO - buy-box v14: stars next to USA + hide dup; simplify; tighten; hideNative; installments; Top Seller; Love Sale hidden; geo ETA (credit countdown removed) === */
(function(){
  if(!/\/products\//.test(location.pathname))return;
  var G='#0F8A6C', INK='#2C2C2A', GOLD='#FFC107';
  function css(){
    if(document.getElementById('ap-bb-css'))return;
    var c='.product variant-selects{display:block;margin-top:15px !important;margin-bottom:3px !important;}'+
      '.product .product-form__buttons{margin-top:10px !important;}'+
      'shopify-payment-terms{font-size:11px !important;line-height:1.2 !important;margin:1px 0 5px !important;display:block;}'+
      '.ap-rate-row{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin:0 0 6px !important;}'+
      '.ap-instant-rating{display:inline-flex;align-items:center;gap:5px;font-size:14px;line-height:1.2;}'+
      '.ap-instant-rating .stars{color:'+GOLD+';letter-spacing:2px;font-size:17px;}'+
      '.ap-instant-rating .num{color:'+INK+';font-weight:600;}'+
      '.ap-instant-rating a{color:#6B6B67;text-decoration:underline;font-size:12px;}'+
      '.ap-bb-eta{font-size:11px;color:'+INK+';margin:6px 0 2px !important;line-height:1.35;}'+
      '.ap-bb-eta .i{color:'+G+';}'+
      '.product variant-selects .product-form__input--pill label.ap-pop{overflow:visible !important;}'+
      '.ap-topseller{position:absolute;top:-11px;left:50%;transform:translateX(-50%);background:'+INK+';color:#fff;font-size:10px;padding:2px 8px;border-radius:9px;white-space:nowrap;font-weight:600;letter-spacing:.02em;z-index:3;line-height:1.1;}'+
      '.ap-song-simple{color:'+G+' !important;font-size:12px !important;font-weight:500 !important;}';
    var s=document.createElement('style');s.id='ap-bb-css';s.textContent=c;document.head.appendChild(s);
  }
  function isReviewish(e){ return /stamped|jdgm|loox|spr-|yotpo|okeReviews|review|rating|star/i.test((e.className||'')+' '+(e.id||'')); }
  function nativeBadge(){
    var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return null;
    var n=info.querySelector('.stamped-badge, .stamped-product-reviews-badge, .stamped-main-badge, .jdgm-prev-badge, .loox-rating, .spr-badge, .yotpo-bottomline, [class*="stamped"][class*="badge"]');
    return (n && n.offsetParent!==null && /\d/.test(n.textContent||'')) ? n : null;
  }
  function hideNativeDup(){ var n=nativeBadge(); if(n && !n.dataset.apDup){ n.dataset.apDup='1'; n.style.setProperty('display','none','important'); } }
  function findUSABadge(){
    var sc=document.querySelector('.product')||document;
    var nodes=sc.querySelectorAll('span,div,p,small');
    for(var i=0;i<nodes.length;i++){ var e=nodes[i]; if(e.children.length>0) continue; var t=(e.textContent||'').trim(); if(/^made in usa$/i.test(t) && e.offsetParent!==null) return e; }
    return null;
  }
  function instantRating(){
    if(document.querySelector('.ap-instant-rating'))return;
    var stars=document.createElement('span'); stars.className='ap-instant-rating';
    stars.innerHTML='<span class="stars">★★★★★</span><span class="num">4.97</span><a href="#shopify-product-reviews">4,503 reviews</a>';
    var badge=findUSABadge();
    if(badge && badge.parentNode && !badge.dataset.apRated){
      badge.dataset.apRated='1';
      var row=document.createElement('div'); row.className='ap-rate-row';
      badge.parentNode.insertBefore(row, badge); row.appendChild(badge); row.appendChild(stars);
    } else {
      var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return;
      var title=info.querySelector('.product__title, h1');
      if(title && title.parentNode) title.parentNode.insertBefore(stars, title); else info.insertBefore(stars, info.firstChild);
    }
  }
  function hideNative(){
    var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return;
    var pats=[/buy 2 canvas|pairup20/i, /free hanging frame|love15/i, /selling fast|in \d+ carts/i, /order within/i];
    info.querySelectorAll('p, span, div').forEach(function(e){
      if(e.dataset.apHid) return; if(e.children.length>2) return; if(isReviewish(e)) return;
      var txt=(e.textContent||'').trim(); if(!txt || txt.length>140) return;
      if(/review|★|stars?/i.test(txt)) return;
      for(var i=0;i<pats.length;i++){ if(pats[i].test(txt)){ e.style.setProperty('display','none','important'); e.dataset.apHid='1'; break; } }
    });
    ['#deliveryDate','#countdownTimer'].forEach(function(sel){ var n=document.querySelector(sel); if(n && !isReviewish(n)) n.style.setProperty('display','none','important'); });
  }
  function simplifySong(){
    var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return;
    info.querySelectorAll('p, div, span, small').forEach(function(e){
      if(e.dataset.apSong || e.children.length>1) return;
      var t=(e.textContent||'');
      if(/we can do any song|can.?t choose a song|decide later|send (a )?preview to your email/i.test(t) && t.length<300){
        e.textContent='✓ Any song, any artist, any language';
        e.className=(e.className||'')+' ap-song-simple'; e.dataset.apSong='1';
      }
    });
  }
  function tightenReviews(){
    var w=document.querySelector('.stamped-main-widget, [id*="stamped"], #shopify-product-reviews, .spr-container, .yotpo, .jdgm-rev-widg');
    if(!w) return;
    if(!w.dataset.apRv){ var sec=w.closest('.shopify-section')||w.parentElement; if(sec){ sec.style.setProperty('padding-top','6px','important'); sec.style.setProperty('margin-top','0','important'); } w.dataset.apRv='1'; }
  }
  function hideLoveSale(){
    var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return;
    info.querySelectorAll('span,div,p,[class*="badge"]').forEach(function(e){
      if(isReviewish(e))return;
      if(e.children.length===0 && /love sale/i.test(e.textContent||'') && e.offsetParent!==null && !e.dataset.apHl){ e.style.setProperty('display','none','important'); e.dataset.apHl='1'; }
    });
  }
  function movePay(){
    var pt=document.querySelector('shopify-payment-terms'); if(!pt||pt.getAttribute('data-ap-mv')==='1')return;
    var price=document.querySelector('.product .price, .product__info-container .price, .product__info-wrapper .price'); if(!price||!price.parentNode)return;
    price.parentNode.insertBefore(pt, price.nextSibling); pt.setAttribute('data-ap-mv','1');
  }
  function popLabel(){ document.querySelectorAll('.product .product-form__input--pill label').forEach(function(l){ if(/24x48/i.test((l.textContent||'').replace(/\s+/g,''))) l.classList.add('ap-pop'); }); }
  function topSeller(){
    popLabel();
    var l=document.querySelector('.product .product-form__input--pill label.ap-pop'); if(!l||l.querySelector('.ap-topseller'))return;
    if(getComputedStyle(l).position==='static') l.style.position='relative';
    var b=document.createElement('span');b.className='ap-topseller';b.textContent='🔥 Top Seller';l.appendChild(b);
  }
  function etaDate(){ var d=new Date(); d.setDate(d.getDate()+(d.getHours()<14?9:10)); return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'}); }
  function deliveryETA(){
    var sw=document.querySelector('.product variant-selects'); if(!sw||document.querySelector('.ap-bb-eta'))return;
    var date=etaDate();
    var el=document.createElement('div');el.className='ap-bb-eta';
    el.innerHTML='<span class="i">🚚</span> Get it by <b>'+date+'</b> — order today';
    sw.parentNode.insertBefore(el, sw.nextSibling);
    try{ fetch('https://ipapi.co/json/').then(function(r){return r.json();}).then(function(j){
        if(j && j.city){ var loc=j.city+(j.region_code?(', '+j.region_code):''); el.innerHTML='<span class="i">🚚</span> Deliver to <b>'+loc+'</b> · Get it by <b>'+date+'</b>'; }
      }).catch(function(){}); }catch(e){}
  }
  function boot(){ css();instantRating();hideNativeDup();hideNative();simplifySong();hideLoveSale();movePay();topSeller();deliveryETA();tightenReviews(); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(){setTimeout(boot,200);});
  setTimeout(boot,800);setTimeout(boot,1600);setTimeout(boot,3000);
  try{ var mo=new MutationObserver(function(){ tightenReviews(); hideNativeDup(); }); mo.observe(document.body,{childList:true,subtree:true}); setTimeout(function(){mo.disconnect();},120000); }catch(e){}
})();
